import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import withModal from '../../../../../components/global/modal/withModal';
import DismissButton from '../../../../../components/global/DismissButton';
import Spinner from '../../../../../components/global/Spinner';

const propTypes = {
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  videoId: PropTypes.string.isRequired,
  header: PropTypes.string,
  footer: PropTypes.string,
  assetUrl: PropTypes.string,
};

export const EVENT_ADDON_ITEM_INFORMATION =
  'modal/EVENT_ADDON_ITEM_INFORMATION';

const EventAddonItemInformationModal = ({
  className,
  onClose,
  title,
  header,
  footer,
  videoId,
  assetUrl,
}) => {
  const classes = classNames({
    [className]: !!className,
  });

  return (
    <div className={classes}>
      <div className="mb-1 text-right">
        <DismissButton onClick={onClose} />
      </div>
      <h3 className="text-center">{title}</h3>
      {header && <p className="text-center">{header}</p>}
      {videoId && (
        <div className="event-addon-item-information-video-container">
          <Spinner />
          <iframe
            title={videoId}
            src={`//www.youtube.com/embed/${videoId}`}
            frameBorder="0"
            allowFullScreen="true"
            webkitallowfullscreen="true"
            mozallowfullscreen="true"
            allow="fullscreen"
            tabIndex="-1"
          />
        </div>
      )}
      {assetUrl && (
        <div className="event-addon-item-information-image-container">
          <img src={assetUrl} alt="How it works" />
        </div>
      )}
      {footer && <p className="text-center">{footer}</p>}
    </div>
  );
};

EventAddonItemInformationModal.propTypes = propTypes;

const EventAddonItemInformationModalWrapper = ({
  actionProps = {},
  onClose,
  onRequestClose,
  ...props
}) => {
  return (
    <EventAddonItemInformationModal
      {...props}
      onClose={onClose || onRequestClose}
      {...actionProps}
    />
  );
};

export default withModal(EventAddonItemInformationModalWrapper, {
  name: EVENT_ADDON_ITEM_INFORMATION,
  dismissible: false,
  hideHeader: true,
  type: 'full',
  size: 'sm',
});
